import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReferenceDataLabels } from '../../../../../lib/constants/reference-data-labels';
import { BaseFormControlComponent } from '../../../../shared/components/form-inputs/base-form-control.component';

@Component({
  selector: 'boi-form-term-input',
  templateUrl: './form-term-input.component.html',
  styleUrls: ['./form-term-input.component.scss']
})
export class FormTermInputComponent extends BaseFormControlComponent {
  referenceDataLabels = ReferenceDataLabels;

  @Input() public years?: number;
  @Input() public months?: number;
  @Output() public readonly yearsChange = new EventEmitter<number>();
  @Output() public readonly monthsChange = new EventEmitter<number>();

  constructor() {
    super();
  }
}
